/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Journey,
    JourneyFromJSON,
    JourneyFromJSONTyped,
    JourneyToJSON,
} from './';

/**
 * 
 * @export
 * @interface JourneyTTLOCriteriaOutput
 */
export interface JourneyTTLOCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof JourneyTTLOCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {Journey}
     * @memberof JourneyTTLOCriteriaOutput
     */
    value?: Journey;
}

export function JourneyTTLOCriteriaOutputFromJSON(json: any): JourneyTTLOCriteriaOutput {
    return JourneyTTLOCriteriaOutputFromJSONTyped(json, false);
}

export function JourneyTTLOCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyTTLOCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : JourneyFromJSON(json['value']),
    };
}

export function JourneyTTLOCriteriaOutputToJSON(value?: JourneyTTLOCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': JourneyToJSON(value.value),
    };
}


